export type PasswordValidation = {
  longEnough: boolean;
  hasOneNumber: boolean;
  hasUppercase: boolean;
};

export function validatePasswordPolicy(password: string): PasswordValidation {
  const longEnough = password.length > 7;
  const hasOneNumber = /\d/.test(password);
  const hasUppercase = password !== password.toLowerCase();
  return { longEnough, hasOneNumber, hasUppercase };
}
